import * as React from 'react'
import { SVGProps } from 'react'

const LTCUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16.1276' cy='15.8608' r='14.2614' fill='#345D9D' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 15.994C0 7.16078 7.16075 0 15.994 0H16.0869C20.3165 0.0123071 24.3679 1.70431 27.3499 4.70378C30.3319 7.70325 32.0003 11.7645 31.988 15.994C31.988 24.8273 24.8272 31.9881 15.994 31.9881C7.16075 31.9881 0 24.8273 0 15.994ZM14.5986 22.1515L16.2638 16.5362L18.8585 15.8004L19.4006 13.9415L16.8447 14.716L19.5555 5.49914V5.35198C19.5515 5.23281 19.5002 5.12014 19.4131 5.03878C19.3259 4.95743 19.21 4.91406 19.0908 4.91824H15.6442C15.3757 4.90997 15.1361 5.08567 15.0633 5.34424L11.849 16.2651L9.29305 17.0396L8.71215 18.8211L11.2681 18.0465L8.98323 25.8306H22.6149C22.8843 25.8417 23.1255 25.6648 23.1958 25.4046L23.9703 22.7324V22.5853C23.9663 22.4661 23.915 22.3534 23.8279 22.2721C23.7407 22.1907 23.6248 22.1474 23.5056 22.1515H14.5986Z'
      fill='white'
    />
  </svg>
)

export default LTCUSD
